import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ResidentProfile from "./pages/ResidentProfile";
import Logs from "./pages/Logs";
import Settings from "./pages/Settings";
import Simulation from "./pages/Simulation";
import GeneralSettings from "./pages/GeneralSettings";
import Appointments from "./pages/Appointments";
import { TranslationProvider } from "./contexts/TranslationContext";
import { ThemeProvider } from "./contexts/ThemeContext";

function App() {
  return (
    <ThemeProvider>
      <TranslationProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Navigate to="/" replace />} />
              <Route path="/resident/:id" element={<ResidentProfile />} />
              <Route path="/logs" element={<Logs />} />
              <Route path="/settings/:id" element={<Settings />} />
              <Route path="/simulation" element={<Simulation />} />
              <Route path="/general-settings" element={<GeneralSettings />} />
              <Route path="/appointments" element={<Appointments />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </TranslationProvider>
    </ThemeProvider>
  );
}

export default App;
